export const TRANSITION_DURATION = '0.5s';
